"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'question.list.title': '问题',
    'question.list.empty': '未找到问题',
};
